import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-400 border border-secondary-500/20 mb-3">
            <i className="ri-question-answer-line mr-1"></i>常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于琪琪影院，你可能想了解这些</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={item.q}
              className="rounded-xl bg-background-50 border border-background-200/50 overflow-hidden"
            >
              <button
                type="button"
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span
                  className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-primary-500/15 text-primary-400 rotate-45'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}